/*
 * Page Transitions ERMOS — controlador global (saida + bfcache + prefetch).
 *
 * Estados (classes no <html>):
 *   idle -> pt-leaving (cobrindo) -> [navegacao do browser] -> pt-arriving (coberto,
 *   ja na pagina nova) -> pt-arriving.pt-revealing -> idle
 * A chegada/reveal roda inline no <head> (snippets/page-transition-head.liquid)
 * para existir antes da primeira pintura e nunca depender deste arquivo.
 *
 * NAO e uma SPA: cada pagina continua sendo um documento Shopify normal
 * (scripts, pixels, analytics, apps, formularios e checkout intactos).
 * Sem JS, os links funcionam normalmente — isto e so uma camada de experiencia.
 */
(function () {
  if (window.__ermosPTInit) return;
  window.__ermosPTInit = true;

  var d = document.documentElement;
  var layer = document.querySelector('[data-page-transition]');
  if (!layer || !window.ErmosPT) return;

  var KEY = window.ErmosPT.key;
  var ms = window.ErmosPT.ms;
  var busy = false;          /* isTransitioning: bloqueia navegacoes concorrentes */
  var safetyTimer = null;

  /* Rotas que nunca recebem transicao: acoes do carrinho, checkout, logout, admin,
     endpoints do Shopify e arquivos. Checkout tem prioridade sobre animacao. */
  var SKIP_PATH = /^\/(cart\/|checkout|checkouts|account\/logout|admin|apps\/|services\/|tools\/|password)/i;
  var FILE_EXT = /\.(pdf|zip|jpe?g|png|gif|webp|svg|mp4|mov|csv|xlsx?|docx?)$/i;

  /* Decide se o link e uma navegacao de pagina elegivel. Devolve a URL ou null. */
  function eligibleUrl(a) {
    if (!a || !a.getAttribute) return null;
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#') return null;
    if (/^(mailto|tel|sms|javascript|data):/i.test(raw)) return null;
    if (a.hasAttribute('download')) return null;
    var target = (a.getAttribute('target') || '').toLowerCase();
    if (target && target !== '_self') return null;
    if (a.closest('[data-no-transition]')) return null;

    var url;
    try { url = new URL(a.href, window.location.href); } catch (e) { return null; }
    if (url.origin !== window.location.origin) return null;        /* links externos */
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    if (SKIP_PATH.test(url.pathname) || FILE_EXT.test(url.pathname)) return null;
    /* Mesma pagina (so muda o hash, ou e o proprio endereco): comportamento nativo. */
    if (url.pathname === window.location.pathname && url.search === window.location.search) return null;
    return url.href;
  }

  /* Prefetch sob demanda (clique) — o do hover continua mais abaixo, so com mouse. */
  var warmed = {};
  function warm(href) {
    if (!href || warmed[href]) return;
    warmed[href] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function leave(href) {
    busy = true;
    try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now() })); } catch (e) {}
    d.classList.remove('pt-arriving', 'pt-revealing');
    d.classList.add('pt-leaving');   /* a camada comeca a subir no proximo frame */

    /* A rede comeca AGORA, no clique: um <link rel=prefetch> puxa a proxima pagina
       enquanto a diagonal roda, entao a espera de rede acontece por tras da animacao
       e nao depois dela. (Safari ignora prefetch; la a navegacao e que busca.) */
    warm(href);

    /* A navegacao so troca o documento perto do fim da cobertura: com 0.4 a diagonal
       era cortada no meio e o efeito virava um flash. 0.75 mostra a frente diagonal
       inteira e o resto ja esta praticamente coberto quando a pagina nova assume —
       que, por sua vez, ja nasce solida (pt-arriving). Unico numero a mexer se o
       clique parecer lento. */
    setTimeout(function () {
      window.location.assign(href);
      /* Navegacao cancelada/sem resposta: a pagina nao fica presa coberta. */
      safetyTimer = setTimeout(function () {
        busy = false;
        try { sessionStorage.removeItem(KEY); } catch (e) {}
        window.ErmosPT.reveal();
      }, 10000);
    }, Math.round(ms('--pt-in', 520) * 0.75));
  }

  /* Listener no WINDOW, fase de bolha: roda DEPOIS de todos os handlers do tema.
     Qualquer interacao que nao e navegacao (menu, busca, carrinho, wishlist, quick
     add, galeria, filtros/paginacao AJAX, arrasto de carrossel) ja chamou
     preventDefault() ou stopPropagation() — entao basta respeitar isso. */
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;

    /* cmd/ctrl/shift/alt + clique e botao do meio: nova aba/janela, sempre nativo
       (inclusive durante uma transicao em curso). */
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    if (busy) {                   /* cliques repetidos durante a transicao: ignorados */
      if (eligibleUrl(a)) e.preventDefault();
      return;
    }

    var href = eligibleUrl(a);
    if (!href) return;
    e.preventDefault();
    leave(href);
  });

  /* Voltar/avancar com bfcache: a pagina volta exatamente como foi deixada —
     coberta. Fecha overlays abertos (menu/busca/carrinho escutam ESC) e revela.
     Nenhum beforeunload/unload e registrado: o bfcache continua funcionando. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    clearTimeout(safetyTimer);
    busy = false;
    try { sessionStorage.removeItem(KEY); } catch (err) {}
    if (d.classList.contains('pt-leaving') || d.classList.contains('pt-arriving')) {
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
      window.ErmosPT.reveal();
    }
  });

  /* Prefetch por intencao de hover — SO com mouse/trackpad.
     Em touch nao ha nenhum listener aqui: mouseover/touchstart disparam durante o
     proprio toque, e agendar timer + inserir nos no DOM nessa janela e exatamente o
     que o Safari iOS interpreta como "hover que revelou conteudo" — ele entao segura
     o clique e o usuario precisa tocar de novo. (Safari tambem nao suporta
     rel=prefetch, entao no iPhone nao havia ganho nenhum.) */
  var hasRealHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var conn = navigator.connection;
  var canPrefetch = hasRealHover && !(conn && (conn.saveData || /(^|-)2g/.test(conn.effectiveType || '')));

  if (canPrefetch) {
    var prefetched = {};
    var prefetchCount = 0;
    var hoverTimer = null;

    var prefetch = function (a) {
      if (prefetchCount >= 30) return;
      var href = eligibleUrl(a);
      if (!href || prefetched[href]) return;
      prefetched[href] = true;
      prefetchCount++;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'document';
      link.href = href;
      document.head.appendChild(link);
    };

    document.addEventListener('mouseover', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { prefetch(a); }, 80);
    }, { passive: true });
  }
})();
